// 고치기 창: 연출컷과 무대 시안이 같은 모양을 쓴다. 왼쪽에 고칠 그림, 오른쪽에 고칠 곳 줄(1~3개)
import { icon } from "../icons";
import { busy, h, helpTip, modal, openViewer, withCost, type Child } from "../lib";

type FixRowCtl<T> = { body: Child; value: () => T; focus?: () => void };

export function openFixDialog<T>(o: {
  title: string;
  src: string;
  alt: string;
  warn?: string; // 위에 한 줄 주황 안내
  help?: string; // '고칠 곳' 옆 도움말
  cost: number;
  newRow: () => FixRowCtl<T>;
  submit: (values: T[], close: () => void) => Promise<void>;
}) {
  type Row = { el: HTMLElement; ctl: FixRowCtl<T> };
  const rows: Row[] = [];
  const list = h("div", { class: "stack" });
  const addBtn = h("button", { class: "btn ghost", type: "button", onclick: () => addRow(true) }, icon("plus"), "고칠 곳 더하기");
  const send = h("button", { class: "btn primary", type: "button" }, withCost("고치기", o.cost));

  const relabel = () => {
    rows.forEach((r, i) => {
      r.el.querySelector(".fix-badge")!.textContent = "ABC"[i];
      const x = r.el.querySelector<HTMLButtonElement>(".fix-x")!;
      x.hidden = rows.length < 2;
      x.setAttribute("aria-label", `${"ABC"[i]} 고칠 곳 빼기`);
    });
    addBtn.disabled = rows.length >= 3;
    addBtn.title = rows.length >= 3 ? "한 번에 세 군데까지 고칠 수 있어요" : "";
  };

  function addRow(focus: boolean) {
    if (rows.length >= 3) return;
    const ctl = o.newRow();
    const el: HTMLElement = h(
      "div",
      { class: "card flat fix-row" },
      h(
        "div",
        { class: "fix-row-head" },
        h("span", { class: "fix-badge", "aria-hidden": "true" }),
        h(
          "button",
          {
            class: "btn ghost small icon-only fix-x",
            type: "button",
            onclick: () => {
              const i = rows.findIndex((r) => r.el === el);
              if (i >= 0) rows.splice(i, 1);
              el.remove();
              relabel();
            },
          },
          icon("x", 16),
        ),
      ),
      ctl.body,
    );
    rows.push({ el, ctl });
    list.append(el);
    relabel();
    if (focus) ctl.focus?.();
  }
  addRow(false);

  const close = modal(
    o.title,
    h(
      "div",
      { class: "fix-layout" },
      h(
        "div",
        { class: "fix-image" },
        h("button", { class: "fix-image-btn", type: "button", "aria-label": "고칠 그림 크게 보기", onclick: () => openViewer([{ src: o.src, title: o.alt }]) }, h("img", { src: o.src, alt: o.alt })),
        h("span", { class: "xs muted hide-sm" }, "누르면 크게 볼 수 있어요"),
      ),
      h(
        "div",
        { class: "stack" },
        o.warn ? h("div", { class: "notice warn small" }, icon("alert", 16), h("span", null, o.warn)) : null,
        h("div", { class: "fix-side-head" }, h("h3", null, "고칠 곳"), o.help ? helpTip(o.help) : null),
        list,
      ),
    ),
    {
      size: "xl",
      cls: "fix-modal",
      sub: "고칠 곳만 짚어 주세요. 나머지는 그대로 둬요",
      foot: [h("div", { class: "left" }, addBtn), h("button", { class: "btn ghost hide-sm", type: "button", onclick: () => close() }, "취소"), send],
    },
  );
  send.addEventListener("click", () => busy(send, "정리하는 중", () => o.submit(rows.map((r) => r.ctl.value()), close), { timer: true }));
}
